import { SET_BUSINESSES } from '../actions/types';

const initialState = {
  items: [],
  meta: null,
};

export default function businesses(state = initialState, action = {}) {
  switch (action.type) {
    case SET_BUSINESSES:
      return {
        items: action.payload.items || [],
        meta: action.payload.meta || null,
      };

    default:
      return state;
  }
}
